import { Modal, Button } from "antd";

import InfoSection from "@/pages/TaskTemplates/InfoSection";

const TaskTemplateInfoModal = ({
  data,
  readOnly,
  status,
  priority,
  taskType,
  is_overdue,
  isUserCanEditTemplate,
  setIsGroupTask,
  showSetMeExecutor,
  showSetMeAcceptor,
  setMeExecutor,
  setMeAcceptor,
  visible,
  onOk,
  onCancel,
}) => {
  return (
    <Modal
      maskClosable={false}
      title="Информация"
      open={visible}
      onOk={onOk}
      onCancel={onCancel}
      okText="Редактировать"
      cancelText="Закрыть"
      width={600}
      footer={
        readOnly
          ? [
              <Button key="cancel" onClick={onCancel}>
                Закрыть
              </Button>,
            ]
          : undefined // стандартный footer с двумя кнопками
      }
    >
      <InfoSection
        data={data}
        status={status}
        priority={priority}
        taskType={taskType}
        is_overdue={is_overdue}
        isUserCanEditTemplate={isUserCanEditTemplate}
        handleEditTask={onOk}
        showSetMeExecutor={showSetMeExecutor}
        showSetMeAcceptor={showSetMeAcceptor}
        setMeExecutor={setMeExecutor}
        setMeAcceptor={setMeAcceptor}
        setIsGroupTask={setIsGroupTask}
      />
    </Modal>
  );
};

export default TaskTemplateInfoModal;
